export const CalendarTriggerPosition = {
  INSIDE: 'inside',
  OUTSIDE: 'outside'
};